module.exports = __webpack_public_path__ + "static/evergreen-pane-borders-b1d52211c1b7e6abb3d0be45154f3630.png";